// メールアドレス入力
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import Block from '../../molecules/Block';
import Annotation from '../../atoms/Annotation';
import Text from '../../molecules/Text';
import CenterButton from '../../atoms/CenterButton';
import TransitionButton from '../../molecules/TransitionButton';
import Heading from '../../molecules/Heading';
import { handleBrowserBack } from '../../BrowserBack';
import axios from '../../axios';
import LoadingModal from '../../molecules/LoadingModal';

const MailAddressRegister = () => {
  // URLパラメータ取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const jacode = url_params.get('jacode');

  // メールアドレス
  const [email, setEmail] = useState('');
  // エラーメッセージ
  const [error_email, setErrorEmail] = useState('');
  // ローディング画面表示制御
  const [is_loading, setIsLoading] = useState(false);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  // email入力毎に更新される
  const handleChangeEmail = (value: string) => {
    setEmail(value);
  };

  /**
   * email送信処理
   * @param email 入力したメールアドレス
   */
  const sendMail = async (email: string) => {
    try {
      setIsLoading(true);

      // エラーメッセージの初期化
      setErrorEmail('');

      const response = await axios.post(`${location.origin}${process.env.MIX_MOCK_URL}/applicant/api/send_mail_register`, {
        email,
        jacode,
      });

      if (response.data.result) {
        // メール送信成功は返されたURLに遷移する
        location.href = response.data.url;
      } else {
        // メール送信失敗はアラートを表示する。
        alert(response.data.message);
        setIsLoading(false);
      }
    } catch (error) {
      if (typeof error.response !== 'undefined' && error.response.data.message.email) {
        // バリデーションエラー
        setErrorEmail(error.response.data.message.email[0]);
      } else {
        alert('システムエラーが発生しました');
      }
      setIsLoading(false);
    }
  };

  // 戻るボタン押下時の処理
  const backTransition = () => {
    const node = document.getElementById('mail-address-register');
    location.replace(node?.dataset.referer as string);
  };

  return (
    <>
      <Heading label="事前審査申込" size="l" />
      <Block
        label="メールアドレス入力"
        content={
          <>
            <Annotation text="メールアドレスを入力し「送信」ボタンを押すと、入力されたメールアドレス宛に確認メールを送信いたします。" />
            <div className="mt-3">
              <Text
                id="email"
                label="メールアドレス"
                type="text"
                value={email}
                placeholder="example@example.com"
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeEmail(event.target.value)
                }
                disabled={false}
                maxlength={50}
                message={error_email}
                display_border={true}
              />
            </div>
            <Annotation text="確認メールは「no-reply@entry.ja-netloan.jp」から送信されます。受信可能なメール設定をお願いいたします。" />
            <div className="content-box">
              <CenterButton
                label="送信"
                btn_class="arrow-right"
                handleClick={() => sendMail(email)}
              />
              <div className="mt-5">
                <TransitionButton label="戻る" handleClick={backTransition} />
              </div>
            </div>
          </>
        }
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

if (document.getElementById('mail-address-register')) {
  render(<MailAddressRegister />, document.getElementById('mail-address-register'));
}
